var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"author with-avatar",attrs:{"href":"#"}},[_c('img',{attrs:{"alt":"","src":_vm.current.image}}),_c('span',[_vm._v(_vm._s(_vm.current.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }